import { Spinner } from '@frontend/components/common';
import { DateBadge } from '@frontend/elements';
import { MyIdentificationClient } from '@frontend/identification/api';
import { CommonMessage } from '@frontend/lang';
import { ToastUtil } from '@frontend/toast-utils';
import { FormattedMessage } from 'react-intl';

import { DeleteModal } from '../../../../modal/delete-modal/delete-modal.component';
import { DefaultContainer } from '../../../../modal/detail-modal/default-container/default-container';
import { ApiKeyCreate } from '../api-key-create/api-key-create.component';
import { ApiKeyUpdate } from '../api-key-update/api-key-update.component';
import { useApiKeyCard } from './api-key-card.controller';

export interface ApiKeyCardProps {
    entity_id: string;
    selfService?: boolean;
}
export const ApiKeyCard = (props: ApiKeyCardProps) => {
    const viewProps = useApiKeyCard(props);
    return (
        <DefaultContainer
            title={CommonMessage.OBJECTS.IDENTIFICATION.API_KEY}
            content={
                viewProps.isLoading && !viewProps.apiKey ? (
                    <Spinner />
                ) : (
                    <div className='inline-flex flex-col items-start justify-start gap-4 self-stretch'>
                        <div className='flex flex-col items-start justify-start gap-[3px]'>
                            <div className='text-brand-muted justify-start text-base font-medium'>
                                <FormattedMessage
                                    id='api-key-card.key'
                                    defaultMessage='Key'
                                    description='Label for API key'
                                />
                            </div>
                            <div className='text-foreground-default w-52 justify-start text-base font-medium'>{viewProps.apiKey?.key}</div>
                        </div>
                        {viewProps.apiKey?.valid_timestamp && (
                            <div className='flex flex-col items-start justify-start gap-[3px]'>
                                <div className='text-brand-muted justify-start text-base font-medium'>{CommonMessage.OBJECTS.PIN_CODE.VALID_UNTIL}</div>
                                <div className='text-foreground-default w-52 justify-start text-base font-medium'>
                                    <DateBadge
                                        date={viewProps.apiKey.valid_timestamp}
                                        inline
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )
            }
            update={
                !viewProps.apiKey || !props.selfService
                    ? {
                          onUpdate: () =>
                              viewProps.apiKey
                                  ? viewProps.openModal(viewProps.updateApiKeyId, () => (
                                        <ApiKeyUpdate
                                            apiKey={viewProps.apiKey!}
                                            onSubmitSuccess={viewProps.setApiKey}
                                        />
                                    ))
                                  : viewProps.openModal(viewProps.createApiKeyId, () => (
                                        <ApiKeyCreate
                                            entity_id={props.entity_id}
                                            selfService={props.selfService}
                                            onSubmitSuccess={viewProps.setApiKey}
                                        />
                                    ))
                      }
                    : undefined
            }
            {...(viewProps.apiKey &&
                props.selfService && {
                    delete: {
                        onDelete: () =>
                            viewProps.openModal(viewProps.deleteApiKeyId, () => (
                                <DeleteModal
                                    func={() => MyIdentificationClient.deleteIdentification(viewProps.apiKey!.account_id, viewProps.apiKey!.id)}
                                    title={viewProps.apiKey!.key}
                                    description={
                                        <FormattedMessage
                                            id='user.security.apiKey.deleteDescription'
                                            defaultMessage='Are you sure you want to delete this API key? This action cannot be undone.'
                                        />
                                    }
                                    callback={() => viewProps.setApiKey(null)}
                                    onDeleteSuccess={() => ToastUtil.success(CommonMessage.TOAST.DELETE.SUCCESS(viewProps.apiKey!.key))}
                                    entityName={viewProps.apiKey!.key}
                                />
                            ))
                    }
                })}
        />
    );
};
